module.exports = __webpack_public_path__ + "img/Group 27961@2x.98b039d5.png";